(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('about-hero')) return;
  class AboutHero extends HTMLElement {
    connectedCallback() {
      var root = this, reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var go = function () { root.classList.add('in'); };
      /* start the entrance after first paint */
      this._raf0 = requestAnimationFrame(function () { root._raf1 = requestAnimationFrame(go); });
      this._sel = go;
      root.addEventListener('shopify:block:select', go);

      if (reduce || root.dataset.parallax !== 'true') return;
      var floats = [].slice.call(root.querySelectorAll('.ah-f'));
      if (!floats.length) return;
      var visible = true, ticking = false;
      /* cache speeds once instead of reading styles each frame */
      var speeds = floats.map(function (f) { return parseFloat(f.style.getPropertyValue('--sp')) || .05; });
      function update() {
        ticking = false;
        var y = window.scrollY || window.pageYOffset;
        for (var i = 0; i < floats.length; i++) floats[i].style.setProperty('--py', (-y * speeds[i]).toFixed(1) + 'px');
      }
      this._onScroll = function () { if (visible && !ticking) { ticking = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { rootMargin: '100px' });
        this._io.observe(root);
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this._raf0); cancelAnimationFrame(this._raf1);
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._io) this._io.disconnect();
      if (this._sel) this.removeEventListener('shopify:block:select', this._sel);
    }
  }
  customElements.define('about-hero', AboutHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('brand-story-reveal')) return;

  class BrandStoryReveal extends HTMLElement {
    connectedCallback() { this.start(); }
    disconnectedCallback() {
      this.dead = true;
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.timer) clearTimeout(this.timer);
      this.raf = 0;
    }

    start() {
      var root = this, d = root.dataset;
      var text = root.querySelector('.bs-text');
      if (!text) return;
      this.dead = false;
      var ac = this.ac = new AbortController(), sig = { signal: ac.signal };
      var rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      var REVEAL = d.reveal !== 'false', START = (parseFloat(d.start) || 88) / 100, END = (parseFloat(d.end) || 40) / 100;
      var MIN = Math.max(0, Math.min(1, (parseFloat(d.min)) / 100)); if (isNaN(MIN)) MIN = .13;
      var BLUR = parseFloat(d.blur) || 0, K = Math.max(1, parseFloat(d.smooth) || 7);
      var TILT = parseFloat(d.tilt) || 0, DRIFT = parseFloat(d.drift) || 0, ZOOM = (parseFloat(d.zoom) || 0) / 100;

      /* split the story into words (keeps the pink italic words) */
      var words = [].slice.call(text.querySelectorAll('.w'));
      if (!words.length) {
        (function walk(n) {
          [].slice.call(n.childNodes).forEach(function (c) {
            if (c.nodeType === 3) {
              var f = document.createDocumentFragment();
              c.textContent.split(/(\s+)/).forEach(function (p) {
                if (!p) return;
                if (/^\s+$/.test(p)) { f.appendChild(document.createTextNode(' ')); return; }
                var s = document.createElement('span'); s.className = 'w'; s.textContent = p; f.appendChild(s); words.push(s);
              });
              n.replaceChild(f, c);
            } else if (c.nodeType === 1) walk(c);
          });
        })(text);
        text.setAttribute('aria-label', text.textContent.replace(/\s+/g, ' ').trim());
        words.forEach(function (w) { w.setAttribute('aria-hidden', 'true'); });
      }
      var phs = [].slice.call(root.querySelectorAll('.bs-ph'));
      var cur = 0, tgt = 0, last = 0, vh = window.innerHeight, self = this;
      root.classList.add('is-ready');

      function target() {
        var r = text.getBoundingClientRect(), start = vh * START, end = vh * END, centre = r.top + r.height / 2;
        tgt = REVEAL ? Math.max(0, Math.min(1, (start - centre) / (start - end))) : 1;
      }
      function apply(p) {
        var n = words.length, span = .28;
        for (var i = 0; i < n; i++) {
          var a = i / n * (1 - span), k = Math.max(0, Math.min(1, (p - a) / span));
          words[i].style.setProperty('--o', (MIN + (1 - MIN) * k).toFixed(3));
          words[i].style.setProperty('--b', ((1 - k) * BLUR).toFixed(2) + 'px');
        }
        var r = root.getBoundingClientRect(), sp = Math.max(-1, Math.min(1, (vh / 2 - (r.top + r.height / 2)) / (vh * .9)));
        phs.forEach(function (ph) {
          var dir = parseFloat(ph.getAttribute('data-dir')) || 1, inn = ph.firstElementChild, img = inn && inn.firstElementChild;
          var appear = Math.max(0, Math.min(1, p * 1.6));
          ph.style.transform = 'translate3d(' + (dir * (1 - appear) * 90) + 'px,' + (sp * -DRIFT * (dir > 0 ? 1.25 : .8) + (1 - appear) * 40).toFixed(1) + 'px,0)';
          if (inn) inn.style.setProperty('--r', (-dir * (TILT - appear * TILT * .38) + sp * dir * -TILT * .23).toFixed(2) + 'deg');
          if (img) img.style.setProperty('--z', (1 + ZOOM * (1 - appear)).toFixed(3));
        });
      }
      function loop(ts) {
        if (self.dead) return;
        var dt = Math.min(.06, (ts - last) / 1000 || .016); last = ts;
        cur += (tgt - cur) * (1 - Math.exp(-dt * K));
        if (Math.abs(tgt - cur) < .0006) cur = tgt;
        apply(cur);
        self.raf = cur === tgt ? 0 : requestAnimationFrame(loop);
      }
      function kick() {
        target();
        if (rm) { cur = tgt; apply(cur); return; }
        if (!self.raf) { last = performance.now(); self.raf = requestAnimationFrame(loop); }
      }
      window.addEventListener('scroll', kick, { passive: true, signal: ac.signal });
      window.addEventListener('resize', function () { vh = window.innerHeight; kick(); }, sig);
      target(); cur = rm ? 1 : tgt; if (rm) tgt = 1; apply(cur);

      function enter() { root.classList.add('in'); }
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { enter(); self.io.disconnect(); } }, { threshold: .2 });
        this.io.observe(root);
      } else enter();
      this.timer = setTimeout(enter, 3500);
    }
  }
  customElements.define('brand-story-reveal', BrandStoryReveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('category-tiles')) return;
  class CategoryTiles extends HTMLElement {
    connectedCallback() {
      var root = this, shown = false;
      function show() { if (shown) return; shown = true; root.classList.add('in'); }
      root.classList.add('is-ready');
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { show(); root._io.disconnect(); } }, { threshold: .12 });
        this._io.observe(root);
      } else show();
      this._t = setTimeout(show, 4000);
      this._sel = show;
      root.addEventListener('shopify:block:select', show);
    }
    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      clearTimeout(this._t);
      if (this._sel) this.removeEventListener('shopify:block:select', this._sel);
    }
  }
  customElements.define('category-tiles', CategoryTiles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hot-spots-split"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('hot-spots-expand')) return;
  class HotSpotsExpand extends HTMLElement {
    connectedCallback() { this.start(); }
    disconnectedCallback() { this.stop(); }
    stop() {
      if (this.ac) this.ac.abort();
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      (this.fixed || []).forEach(function (f) { f.el.style.overflow = f.v; });
      this.fixed = [];
    }
    start() {
      var root = this, d = root.dataset, ac = this.ac = new AbortController(), sig = { signal: ac.signal };
      var track = root.querySelector('.hse-track'), pin = root.querySelector('.hse-pin'), box = root.querySelector('.hse-scale');
      if (!track || !pin || !box) return;
      var bg = root.querySelector('.hse-bg'), cap = root.querySelector('.hse-caption');
      var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false };
      var PIN = d.pin !== 'false', LEN = (parseFloat(d.length) || 120) / 100, RAD = parseFloat(d.radius) || 0;
      var ZOOM = (parseFloat(d.zoom) || 0) / 100, K = Math.max(1, parseFloat(d.smooth) || 8), SHADOW = d.shadow !== 'false', DOTS = d.dots === 'true';
      var H = 0, vh = 0, T0 = 0, L = 0, S0 = .3, on = true, tgt = 0, cur = 0, lastTs = 0;
      this.fixed = [];

      function freeStickyAncestors() {          /* position:sticky stops working inside overflow:hidden parents, so relax them */
        for (var el = root.parentElement; el && el !== document.documentElement; el = el.parentElement) {
          var cs = getComputedStyle(el);
          if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
            if (cs.overflowX === 'clip' && cs.overflowY === 'clip') continue;
            root.fixed.push({ el: el, v: el.style.overflow }); el.style.overflow = 'clip';
          }
        }
      }
      function reset() {
        box.style.transform = ''; box.style.borderRadius = ''; box.style.boxShadow = ''; box.classList.remove('is-growing');
        box.style.removeProperty('--hse-zoom'); root.style.removeProperty('--hse-dots'); root.style.removeProperty('--hse-dots-pe');
        if (bg) bg.style.opacity = ''; if (cap) { cap.style.opacity = ''; cap.style.transform = ''; }
        pin.style.position = ''; pin.style.top = ''; track.style.height = '';
      }
      function measure() {
        on = !rm && (!mq.matches || d.mobile !== 'false');
        S0 = Math.max(.08, Math.min(1, (mq.matches ? parseFloat(d.startMobile) : parseFloat(d.start)) / 100 || .3));
        reset();
        if (!on) { root.classList.remove('is-ready'); return; }
        H = box.offsetHeight; vh = window.innerHeight;
        T0 = Math.max(0, (vh - H) / 2); L = vh * LEN;
        box.style.transformOrigin = '50% ' + (Math.min(H, vh) / 2) + 'px';
        if (PIN) { track.style.height = (H + L) + 'px'; pin.style.position = 'sticky'; pin.style.top = T0 + 'px'; }
        root.classList.add('is-ready');
        target(); cur = tgt; apply(cur);
      }
      function smoother(p) { return p * p * p * (p * (p * 6 - 15) + 10); }   /* very soft start and finish */
      function target() {
        var r = track.getBoundingClientRect(), p = PIN ? (T0 - r.top) / L : (vh - r.top) / (vh - T0);
        tgt = Math.max(0, Math.min(1, p));
      }
      function apply(p) {
        var e = smoother(p), sc = S0 + (1 - S0) * e;
        box.style.transform = 'scale(' + sc.toFixed(4) + ')';
        box.style.borderRadius = (RAD * (1 - e) / Math.max(sc, .2)).toFixed(1) + 'px';   /* radius stays round while the box is scaled */
        if (SHADOW) box.style.boxShadow = e < .98 ? '0 ' + (50 * (1 - e)).toFixed(0) + 'px ' + (90 * (1 - e)).toFixed(0) + 'px -30px rgba(0,0,0,' + (.5 * (1 - e)).toFixed(3) + ')' : 'none';
        box.classList.toggle('is-growing', e < .999);
        if (ZOOM) box.style.setProperty('--hse-zoom', (1 + ZOOM * (1 - e)).toFixed(4));
        if (bg) bg.style.opacity = (1 - Math.min(1, e * 1.15)).toFixed(3);
        if (cap) { cap.style.opacity = Math.max(0, 1 - e * 2.4).toFixed(3); cap.style.transform = 'translate3d(0,' + (-e * 40).toFixed(1) + 'px,0) scale(' + (1 + e * .12).toFixed(3) + ')'; }
        if (DOTS) { var dd = Math.max(0, Math.min(1, (e - .78) / .22)); root.style.setProperty('--hse-dots', dd.toFixed(3)); root.style.setProperty('--hse-dots-pe', dd > .9 ? 'auto' : 'none'); }
      }
      function loop(ts) {                      /* the picture glides after the scroll position instead of snapping to it */
        var dt = Math.min(.06, (ts - lastTs) / 1000 || .016); lastTs = ts;
        cur += (tgt - cur) * (1 - Math.exp(-dt * K));
        if (Math.abs(tgt - cur) < .0004) cur = tgt;
        apply(cur);
        root.raf = cur === tgt ? 0 : requestAnimationFrame(loop);
      }
      function kick() { if (!on) return; target(); if (!root.raf) { lastTs = performance.now(); root.raf = requestAnimationFrame(loop); } }
      if (PIN) freeStickyAncestors();
      measure();
      window.addEventListener('scroll', kick, { passive: true, signal: ac.signal });
      window.addEventListener('resize', measure, sig);
      window.addEventListener('load', measure, sig);
      if (window.ResizeObserver) { var ro = new ResizeObserver(function () { if (Math.abs(box.offsetHeight - H) > 2) measure(); }); ro.observe(box); ac.signal.addEventListener('abort', function () { ro.disconnect(); }); }
    }
  }
  customElements.define('hot-spots-expand', HotSpotsExpand);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('testimonials-flow')) return;

  class TestimonialsFlow extends HTMLElement {
    connectedCallback() { this.start(); }
    disconnectedCallback() { this.stop(); }

    stop() {
      this.dead = true;
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      if (this.timer) clearTimeout(this.timer);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    start() {
      var root = this, d = root.dataset;
      var track = root.querySelector('.tf-track'), view = root.querySelector('.tf-view');
      if (!track || !view) return;
      this.dead = false;
      var ac = this.ac = new AbortController(), sig = { signal: ac.signal };
      var rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      var SPEED = parseFloat(d.speed) || 0, STAGGER = parseFloat(d.stagger) || 0, DUR = parseFloat(d.duration) || 1400;
      var ENTRANCE = d.entrance !== 'false' && !rm, PAUSE_HOVER = d.pauseHover !== 'false', DRAG = d.draggable !== 'false';
      var orig = [].slice.call(track.children);
      if (!orig.length) return;
      orig.forEach(function (c) { c.classList.add('is-lift'); });

      var x = 0, moved = 0, vel = 0, loopW = 0, hover = false, dragging = false, lx = 0, visible = false, running = false, held = false, last = 0, entered = false;
      var set = orig.slice(), all = [];

      function gapPx() { return parseFloat(getComputedStyle(track).columnGap) || 0; }
      function baseWidth() { return orig.reduce(function (w, c) { return w + c.offsetWidth + gapPx(); }, 0); }

      /* enough cards to fill the screen, then one more copy so the loop has no gap */
      function build() {
        [].slice.call(track.querySelectorAll('.tf-card.clone,.tf-card.dup')).forEach(function (c) { c.remove(); });
        var bw = baseWidth(), reps = 1, W = window.innerWidth;
        set = orig.slice();
        while (bw * reps < W + 40 && reps < 8) {
          orig.forEach(function (c) { var k = c.cloneNode(true); k.classList.add('clone', 'is-lift'); k.setAttribute('aria-hidden', 'true'); k.removeAttribute('data-block-id'); [].forEach.call(k.querySelectorAll('a'), function (a) { a.tabIndex = -1; }); track.appendChild(k); set.push(k); });
          reps++;
        }
        loopW = bw * reps;
        set.forEach(function (c) { var k = c.cloneNode(true); k.classList.add('dup'); k.classList.remove('clone'); k.setAttribute('aria-hidden', 'true'); k.removeAttribute('data-block-id'); [].forEach.call(k.querySelectorAll('a'), function (a) { a.tabIndex = -1; }); track.appendChild(k); });
        all = [].slice.call(track.children);
        if (running) all.forEach(function (c) { c.classList.add('on'); });
      }
      function wrap() { if (loopW) x = ((x % loopW) - loopW) % loopW; }
      function paint() { track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; }

      root.classList.add('is-ready');
      build();

      /* entrance: one by one, from the bottom right, flying left into place */
      function enter() {
        if (entered) return; entered = true;
        var W = window.innerWidth, delay = 0;
        set.forEach(function (c) {
          c.classList.add('on');
          var r = c.getBoundingClientRect();
          if (!ENTRANCE || r.left > W || r.right < 0) return;
          var dx = Math.max(W - r.left + 120, 240);
          c.animate([
            { transform: 'translate3d(' + dx + 'px,340px,0) rotate(9deg) scale(.88)', opacity: 0, filter: 'blur(8px)' },
            { transform: 'translate3d(0,0,0) rotate(0) scale(1)', opacity: 1, filter: 'blur(0)' }
          ], { duration: DUR, delay: delay, easing: 'cubic-bezier(.2,.85,.2,1)', fill: 'backwards' });
          delay += STAGGER;
        });
        root.timer = setTimeout(function () {
          running = true; root.classList.add('is-run'); all.forEach(function (c) { c.classList.add('on'); }); last = performance.now();
        }, ENTRANCE ? delay + DUR : 0);
      }

      /* the belt: eases up to speed, stops on hover, can be dragged */
      var self = this;
      function loop(ts) {
        if (self.dead) return;
        self.raf = requestAnimationFrame(loop);
        var dt = Math.min(.05, (ts - last) / 1000 || 0); last = ts;
        if (!running || !visible || rm) return;
        if (!dragging) { var target = (held || (PAUSE_HOVER && hover)) ? 0 : -SPEED; vel += (target - vel) * Math.min(1, dt * 2.2); x += vel * dt; }
        wrap(); paint();
      }
      this.raf = requestAnimationFrame(loop);

      if (DRAG) {
        track.addEventListener('pointerdown', function (e) { if (!running || (e.pointerType === 'mouse' && e.button !== 0)) return; dragging = true; moved = 0; lx = e.clientX; vel = 0; track.classList.add('grab'); try { track.setPointerCapture(e.pointerId); } catch (_) {} }, sig);
        track.addEventListener('pointermove', function (e) { if (!dragging) return; var dd = e.clientX - lx; lx = e.clientX; x += dd; moved += Math.abs(dd); vel = dd * 50; }, sig);
        var up = function () { if (!dragging) return; dragging = false; track.classList.remove('grab'); vel = Math.max(-1800, Math.min(1800, vel)); };
        track.addEventListener('pointerup', up, sig); track.addEventListener('pointercancel', up, sig);
        track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, { capture: true, signal: ac.signal });
      }
      view.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; }, sig);
      view.addEventListener('pointerleave', function () { hover = false; }, sig);

      var rz;
      window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { var was = x; build(); x = was; wrap(); paint(); }, 200); }, sig);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!self.dead) { build(); } });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) enter(); }, { threshold: .3 });
        this.io.observe(root);
      } else { visible = true; enter(); }
      this.timer = setTimeout(function () { visible = true; enter(); }, 3500);

      /* theme editor: selecting a review stops the belt and brings that card into view */
      root.addEventListener('shopify:block:select', function (e) {
        var i = orig.indexOf(e.target); if (i < 0) return;
        held = true; entered || enter(); running = true; root.classList.add('is-run'); all.forEach(function (c) { c.classList.add('on'); });
        x = -(e.target.offsetLeft - (window.innerWidth - e.target.offsetWidth) / 2); vel = 0; wrap(); paint();
      }, sig);
      root.addEventListener('shopify:block:deselect', function () { held = false; }, sig);
    }
  }
  customElements.define('testimonials-flow', TestimonialsFlow);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('trust-strip')) return;
  class TrustStrip extends HTMLElement {
    connectedCallback() {
      var root = this, done = false;
      this.dead = false;
      root.classList.add('is-ready');
      function show() { if (done) return; done = true; root.classList.add('in'); }
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { show(); root.io.disconnect(); } }, { threshold: .25 });
        this.io.observe(root);
      } else show();
      this.timer = setTimeout(show, 3500);
      /* theme editor: always show the items while editing */
      this.sel = function () { show(); };
      root.addEventListener('shopify:block:select', this.sel);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.timer) clearTimeout(this.timer);
      if (this.sel) this.removeEventListener('shopify:block:select', this.sel);
    }
  }
  customElements.define('trust-strip', TrustStrip);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-arch"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('ugc-video-arch')) return;

  class UgcVideoArch extends HTMLElement {
    connectedCallback() { this.start(); }
    disconnectedCallback() { this.stop(); }

    stop() {
      this.dead = true;
      if (this.ac) this.ac.abort();
      if (this.io) this.io.disconnect();
      if (this.timer) clearTimeout(this.timer);
      (this.cards || []).forEach(function (c) { if (c.__v) { c.__v.pause(); c.__v.removeAttribute('src'); c.__v.load(); } });
    }

    start() {
      var root = this, d = root.dataset;
      var stage = root.querySelector('.uv-stage');
      if (!stage) return;
      this.dead = false;
      var ac = this.ac = new AbortController(), sig = { signal: ac.signal };
      var rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      var canHover = !!(window.matchMedia && matchMedia('(hover: hover)').matches);
      var mobileMQ = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false };

      /* ---- settings from data attributes ---- */
      var FLIP = parseFloat(d.flip) || 1;
      var ARC_D = parseFloat(d.arc) || 0, ARC_M = parseFloat(d.arcMobile) || 0;
      var POWER = parseFloat(d.power) || 2, TILT = parseFloat(d.tilt) || 0;
      var CSCALE = parseFloat(d.centerScale) || 1, SHRINK = parseFloat(d.shrink) || 0;
      var GAP = parseFloat(d.gap) || 0;
      var AUTO = parseFloat(d.auto) || 0;                       /* + = scroll left, - = right */
      var PAUSE_HOVER = d.pauseHover !== 'false';
      var PLAY_ON = d.playOn || 'both';
      var ALL = PLAY_ON === 'all';
      var INTRO = d.intro === 'true' && !rm;
      var INTRO_MS = parseFloat(d.introMs) || 1150, INTRO_GAP = parseFloat(d.introGap) || 130;
      var INTRO_ORDER = d.introOrder || 'ltr';
      var L_PLAY = d.labelPlay || 'Play video', L_ON = d.labelSoundOn || 'Sound on', L_OFF = d.labelSoundOff || 'Sound off';

      var cards = this.cards = [].slice.call(stage.querySelectorAll('.uv-card'));
      var N0 = cards.length;
      if (!N0) return;

      var W = 0, cw = 0, ch = 0, step = 0, total = 0, arc = 0, off = 0, vel = 0, dragging = false, hover = -1, visible = true,
          last = 0, active = -1, moved = 0, inited = false, sound = false, tween = null, hoverLock = false, cen = -1, near = 0,
          introT = null, introDone = !INTRO, introEnd = 0, delays = [];

      function onceVisible(el, cb, th) {
        if (!('IntersectionObserver' in window)) { cb(); return; }
        var o = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { cb(); o.disconnect(); } }, { threshold: th || .2 });
        o.observe(el);
      }

      /* enough cards to fill the loop */
      function fill() {
        var guard = 0;
        while (cards.length * step < W + step * 2.6 && guard++ < 6) {
          for (var k = 0; k < N0; k++) {
            var c = cards[k].cloneNode(true);
            c.removeAttribute('data-block-id'); c.removeAttribute('data-shopify-editor-block');
            c.setAttribute('aria-hidden', 'true'); c.classList.remove('is-playing', 'is-active', 'snd');
            var cv = c.querySelector('.uv-video'); if (cv) cv.remove();
            [].forEach.call(c.querySelectorAll('a,button'), function (el) { el.tabIndex = -1; });
            stage.appendChild(c); cards.push(c);
          }
        }
      }
      function measure() {
        W = stage.clientWidth; cw = cards[0].offsetWidth; ch = cards[0].offsetHeight;
        step = cw + GAP;
        fill();
        total = cards.length * step;
        arc = mobileMQ.matches ? ARC_M : ARC_D;
        root.style.setProperty('--uv-arc', arc + 'px');
        root.style.setProperty('--uv-up', FLIP < 0 ? arc + 'px' : '0px');
        if (!inited) { off = (W - cw) / 2 - step * 1.5; inited = true; }
      }

      /* ---- entrance: cards rise from the bottom one by one ---- */
      function easeBack(t) { var c1 = 1.35, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
      function startIntro() {
        if (introT !== null) return;
        if (!INTRO) { introDone = true; introT = 0; return; }
        var arr = [];
        for (var i = 0; i < cards.length; i++) { var pos = ((i * step + off) % total + total) % total; arr.push({ i: i, cx: pos - step + cw / 2 }); }
        if (INTRO_ORDER === 'rtl') arr.sort(function (a, b) { return b.cx - a.cx; });
        else if (INTRO_ORDER === 'center') arr.sort(function (a, b) { return Math.abs(a.cx - W / 2) - Math.abs(b.cx - W / 2); });
        else arr.sort(function (a, b) { return a.cx - b.cx; });
        var r = 0;
        arr.forEach(function (o) { delays[o.i] = (o.cx > -cw && o.cx < W + cw) ? (r++) * INTRO_GAP : 0; });
        introEnd = Math.max.apply(null, delays) + INTRO_MS + 60; introT = performance.now();
      }

      /* ---- layout of every card on the curve ---- */
      function render() {
        var best = 1e9, bi = 0, now = performance.now(), N = cards.length;
        for (var i = 0; i < N; i++) {
          var pos = ((i * step + off) % total + total) % total, x = pos - step, cx = x + cw / 2, dd = cx - W / 2, t = dd / (W / 2), a = Math.abs(t);
          var y = FLIP * arc * Math.min(Math.pow(a, POWER), 1.6) * (arc ? 1 : 0);
          var rot = FLIP * t * TILT, sc = CSCALE - Math.min(a, 1.3) * SHRINK, op = 1;
          if (!introDone) {
            var k = introT === null ? 0 : Math.max(0, Math.min(1, (now - introT - (delays[i] || 0)) / INTRO_MS)), e = easeBack(k);
            y += (1 - e) * (ch * .8 + 240); sc *= .84 + .16 * Math.min(1, e); op = Math.min(1, k * 2.4);
          }
          var s = cards[i].style;
          s.opacity = introDone ? '' : op;
          s.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
          s.zIndex = 100 - Math.round(a * 60);
          if (Math.abs(dd) < best) { best = Math.abs(dd); bi = i; }
        }
        near = bi;
        cen = best < step * .4 ? bi : -1;
        var byCenter = best < step * .6 ? bi : -1, want;
        if (ALL) {
          for (var j = 0; j < N; j++) {
            var cj = cards[j], pj = ((j * step + off) % total + total) % total, xj = pj - step, vis = xj > -cw * .6 && xj < W - cw * .4;
            if (vis !== cj.__vis) { cj.__vis = vis; if (vis) playQuiet(cj); else if (cj.__v) cj.__v.pause(); }
          }
        }
        if (PLAY_ON === 'center' || ALL || !canHover) want = byCenter;
        else if (PLAY_ON === 'hover') want = hover;
        else want = hover >= 0 ? hover : byCenter;
        if (want !== active) setActive(want);
      }

      /* ---- video on the card ---- */
      function ensureVideo(c) {
        if (c.__v || !c.getAttribute('data-video')) return c.__v;
        var v = document.createElement('video'), bar = c.querySelector('.uv-prog i');
        v.className = 'uv-video'; v.loop = true; v.playsInline = true; v.muted = true;
        v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.preload = 'metadata'; v.src = c.getAttribute('data-video');
        v.addEventListener('playing', function () { c.classList.add('is-playing'); });
        v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
        if (bar) v.addEventListener('timeupdate', function () { if (v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration).toFixed(3) + ')'; });
        var ref = c.querySelector('.uv-save') || c.querySelector('.uv-prog') || c.querySelector('.uv-ctl') || c.querySelector('.uv-info');
        c.insertBefore(v, ref); c.__v = v; return v;
      }
      function label(c) {
        var b = c.querySelector('.uv-ctl'); if (!b) return;
        b.setAttribute('aria-label', !c.classList.contains('is-playing') ? L_PLAY : (c.classList.contains('snd') ? L_OFF : L_ON));
      }
      function play(c) {
        var v = ensureVideo(c); if (!v) return;
        v.muted = !sound; c.classList.toggle('snd', sound);
        var p = v.play();
        if (p && p.catch) p.catch(function (err) {
          if (cards[active] !== c || (err && err.name === 'AbortError')) return;
          v.muted = true; sound = false; c.classList.remove('snd');
          var q = v.play(); if (q && q.catch) q.catch(function () {});
        });
      }
      function playQuiet(c) {                /* 'all visible cards' mode: every card on screen plays, muted unless it is the sound card */
        var v = ensureVideo(c); if (!v) return;
        v.muted = !(sound && cards[active] === c);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      function setActive(i) {
        if (ALL) {
          if (active >= 0) { var o2 = cards[active]; o2.classList.remove('is-active', 'snd'); if (o2.__v) o2.__v.muted = true; }
          active = i; if (i < 0) return;
          var c2 = cards[i]; c2.classList.add('is-active');
          if (c2.__v) { c2.__v.muted = !sound; c2.classList.toggle('snd', sound); }
          return;
        }
        if (active >= 0) { var o = cards[active]; o.classList.remove('is-active', 'snd'); if (o.__v) { o.__v.pause(); o.__v.muted = true; } }
        active = i; if (i < 0) return;
        var c = cards[i]; c.classList.add('is-active');
        if (visible) play(c);
      }
      function toggleSound(c) {
        var v = c.__v; if (!v) return;
        sound = !sound; v.muted = !sound; c.classList.toggle('snd', sound); label(c);
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      function go(i) {
        var pos = ((i * step + off) % total + total) % total, cx = pos - step + cw / 2, delta = ((W / 2 - cx) % total + total) % total;
        if (delta > total / 2) delta -= total;
        tween = { from: off, to: off + delta, t0: performance.now(), dur: 650 }; vel = 0; hover = -1; hoverLock = true;
      }
      root.go = go;
      function ease(t) { return 1 - Math.pow(1 - t, 4); }

      /* ---- main loop ---- */
      var self = this;
      function frame(ts) {
        if (self.dead) return;
        requestAnimationFrame(frame);
        var dt = Math.min(.05, (ts - last) / 1000 || 0); last = ts;
        if (!visible) return;
        if (!introDone) { render(); if (introT !== null && performance.now() - introT > introEnd) introDone = true; return; }
        if (tween) { var k = Math.min(1, (performance.now() - tween.t0) / tween.dur); off = tween.from + (tween.to - tween.from) * ease(k); if (k >= 1) tween = null; }
        else if (!dragging) { var target = ((PAUSE_HOVER && hover >= 0) || rm) ? 0 : -AUTO; vel += (target - vel) * Math.min(1, dt * 2.6); off += vel * dt; }
        render();
      }

      measure(); render();
      onceVisible(stage, startIntro, .3);
      this.timer = setTimeout(startIntro, 3500);                      /* safety net */
      window.addEventListener('resize', function () { measure(); render(); }, sig);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (e) {
          visible = e[0].isIntersecting;
          if (ALL) { cards.forEach(function (c) { if (!visible && c.__v) c.__v.pause(); c.__vis = undefined; }); return; }
          if (!visible && active >= 0 && cards[active].__v) cards[active].__v.pause();
          else if (visible && active >= 0) play(cards[active]);
        }, { threshold: .05 });
        this.io.observe(stage);
      }
      document.addEventListener('visibilitychange', function () {
        if (ALL) { cards.forEach(function (c) { if (document.hidden && c.__v) c.__v.pause(); c.__vis = undefined; }); return; }
        if (document.hidden && active >= 0 && cards[active].__v) cards[active].__v.pause();
        else if (!document.hidden && active >= 0 && visible) play(cards[active]);
      }, sig);
      requestAnimationFrame(frame);

      /* ---- drag / swipe ---- */
      var lx = 0, lt = 0;
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; tween = null; moved = 0; lx = e.clientX; lt = performance.now(); vel = 0;
      }, sig);
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - lx, now = performance.now(), dt = Math.max(1, now - lt) / 1000;
        off += dx; moved += Math.abs(dx); vel = vel * .6 + (dx / dt) * .4; lx = e.clientX; lt = now;
        if (moved > 6) stage.classList.add('grabbing');
      }, sig);
      function up() { if (!dragging) return; dragging = false; stage.classList.remove('grabbing'); vel = Math.max(-2600, Math.min(2600, vel)); }
      window.addEventListener('pointerup', up, sig); window.addEventListener('pointercancel', up, sig);
      stage.addEventListener('click', function (e) { if (moved > 8) { e.preventDefault(); e.stopPropagation(); } }, { capture: true, signal: ac.signal });

      /* ---- clicks (delegated, so cloned cards work too) ---- */
      stage.addEventListener('click', function (e) {
        var c = e.target.closest && e.target.closest('.uv-card'); if (!c) return;
        var i = cards.indexOf(c);
        if (e.target.closest('.uv-ctl')) { e.stopPropagation(); if (active === i) toggleSound(c); else go(i); return; }
        if (e.target.closest('a')) return;                                         /* product links work normally */
        if (!c.getAttribute('data-video')) { if (c.getAttribute('data-shop')) location.href = c.getAttribute('data-shop'); return; }
        if (cen === i) toggleSound(c); else go(i);                                  /* centred: sound on/off, other: glide to centre */
      }, sig);
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || dragging) return;
        if (hoverLock) { if (Math.abs(e.movementX) + Math.abs(e.movementY) < 3) return; hoverLock = false; }
        var c = e.target.closest && e.target.closest('.uv-card'); hover = c ? cards.indexOf(c) : -1;
      }, sig);
      stage.addEventListener('pointerleave', function () { hover = -1; }, sig);
      stage.addEventListener('keydown', function (e) {
        if (e.target !== stage) return;
        if (e.key === 'ArrowRight') { go((near + 1) % cards.length); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go((near - 1 + cards.length) % cards.length); e.preventDefault(); }
      }, sig);

      /* ---- arrow buttons ---- */
      var prev = root.querySelector('.uv-prev'), next = root.querySelector('.uv-next');
      if (next) next.addEventListener('click', function () { go((near + 1) % cards.length); }, sig);
      if (prev) prev.addEventListener('click', function () { go((near - 1 + cards.length) % cards.length); }, sig);

      /* ---- theme editor: selecting a block brings its card to the centre ---- */
      root.addEventListener('shopify:block:select', function (e) {
        var i = cards.indexOf(e.target); if (i >= 0) { introDone = true; go(i); }
      }, sig);
    }
  }
  customElements.define('ugc-video-arch', UgcVideoArch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('values-list')) return;
  class ValuesList extends HTMLElement {
    connectedCallback() {
      var root = this;
      root.classList.add('is-ready');
      /* pin the heading with JS so it works even when the theme clips overflow or uses smooth-scroll wrappers */
      if (root.classList.contains('vl--sticky')) {
        var stick = root.querySelector('.vl-stick'), grid = root.querySelector('.vl-grid');
        var topPx = parseFloat(getComputedStyle(root).getPropertyValue('--vl-top')) || 0;
        var desk = matchMedia('(min-width: 900px)'), vis = true, tick = false;
        var run = function () {
          tick = false;
          if (!desk.matches) { stick.style.transform = ''; return; }
          var g = grid.getBoundingClientRect(), h = stick.offsetHeight;
          var y = Math.max(0, Math.min(topPx - g.top, g.height - h));
          stick.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
        };
        this._req = function () { if (vis && !tick) { tick = true; requestAnimationFrame(run); } };
        root.classList.add('js-pin');
        window.addEventListener('scroll', this._req, { passive: true });
        window.addEventListener('resize', this._req);
        if ('IntersectionObserver' in window) {
          this._pio = new IntersectionObserver(function (e) { vis = e[0].isIntersecting; if (vis) run(); }, { rootMargin: '200px' });
          this._pio.observe(root);
        }
        run();
      }
      var items = [].slice.call(root.querySelectorAll('.vl-rv'));
      function showAll() { items.forEach(function (el) { el.classList.add('in'); }); }
      if (!('IntersectionObserver' in window)) { showAll(); return; }
      this._io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); root._io.unobserve(e.target); } });
      }, { threshold: .15 });
      items.forEach(function (el) { root._io.observe(el); });
      /* touch screens have no hover: highlight the row crossing the middle of the screen */
      if (matchMedia('(hover: none)').matches) {
        this._io2 = new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.target.classList.toggle('active', e.isIntersecting); });
        }, { rootMargin: '-42% 0px -42% 0px' });
        [].slice.call(root.querySelectorAll('.vl-row')).forEach(function (r) { root._io2.observe(r); });
      }
      this._t = setTimeout(showAll, 4500);
      this._sel = showAll;
      root.addEventListener('shopify:block:select', showAll);
    }
    disconnectedCallback() {
      if (this._req) { window.removeEventListener('scroll', this._req); window.removeEventListener('resize', this._req); }
      if (this._pio) this._pio.disconnect();
      if (this._io) this._io.disconnect();
      if (this._io2) this._io2.disconnect();
      clearTimeout(this._t);
      if (this._sel) this.removeEventListener('shopify:block:select', this._sel);
    }
  }
  customElements.define('values-list', ValuesList);
})();

  } catch(e) { console.error(e); }
})();
})();
